import da from '../../assets/flags/da.svg';
import uk from '../../assets/flags/uk.svg';
import fi from '../../assets/flags/fi.svg';
import no from '../../assets/flags/no.svg';
import sv from '../../assets/flags/sv.svg';

const flags = { da, en: uk, fi, no, sv };

export { flags };
